import request from '@/utils/request'
import qs from 'qs'


//查询单个
export function getByWork(id) {
  return request({
    url: 'cyOfficialWork/getByWork',
    params: { id },
    method: 'get',
  })
}
//表单提交


//表单提交
export function submit(data) {
  return request({
    url: '/cyOfficialMessage/submit',
    method: 'post',
    data:qs.stringify(data),
  })
}

//查询案例集
export function officialType(data) {
  return request({
    url: '/cyOfficialWork/officialType',
    method: 'post',
    data:qs.stringify(data),
  })
}

//查询案例精选
export function officialHome() {
  return request({
    url: '/cyOfficialWork/officialHome',
    method: 'get',
  })
}

//表单提交
export function queryTypeList() {
  return request({
    url: '/cyOfficialWorkType/queryTypeList',
    method: 'get',
  })
}










// WEBPACK FOOTER //
// ./src/api/article.js